// extracted by mini-css-extract-plugin
module.exports = {"root":"fcd17ddf","list":"_87174418","label":"_30254ad0","meta":"_9410e209"};